// Hints carry no user data or permissions. Every tab rechecks its own session.
const keyFor = merchantId => `bd-access-change:v1:${encodeURIComponent(merchantId)}`;
export function publishAccessChange(merchantId, environment = window) {
  if (!merchantId) return;
  const key = keyFor(merchantId);
  const hint = { version: 1, nonce: `${Date.now()}:${Math.random()}` };
  let channel;
  try { channel = new environment.BroadcastChannel(key); channel.postMessage(hint); } catch { /* Polling/storage remain available. */ }
  finally { channel?.close(); }
  try { environment.localStorage.setItem(key, JSON.stringify(hint)); } catch { /* Polling remains authoritative. */ }
  environment.dispatchEvent(new CustomEvent(key, { detail: hint }));
}

export function watchAccessChanges(merchantId, refresh, environment = window) {
  const key = keyFor(merchantId);
  let channel;
  const seen = new Set();
  const receive = value => {
    if (value?.version !== 1 || typeof value.nonce !== "string" || value.nonce.length > 150 || seen.has(value.nonce)) return;
    seen.add(value.nonce); if (seen.size > 64) seen.delete(seen.values().next().value);
    refresh();
  };
  const storage = event => { if (event.key === key && event.newValue) { try { receive(JSON.parse(event.newValue)); } catch { /* Ignore malformed hints. */ } } };
  const local = event => receive(event.detail);
  try { channel = new environment.BroadcastChannel(key); channel.onmessage = event => receive(event.data); } catch { /* Storage/polling fallback. */ }
  environment.addEventListener("storage", storage);
  environment.addEventListener(key, local);
  return () => { environment.removeEventListener("storage", storage); environment.removeEventListener(key, local); if (channel) { channel.onmessage = null; channel.close(); } };
}
